import * as c from "../utils/constants/constants";

const LOCK_NAME = "myApp-single-tab";

const restrictTabs = () => {
  const isRestrictedPage = window.location.pathname.endsWith(
    c.PAGE_URLS[c.PAGE_TAB_RESTRICT]
  );
  const isDuplicate = new URLSearchParams(window.location.search).has("duplicate");

  if (isRestrictedPage || isDuplicate) return;

  // Fallback: browser without Web Locks -> don't restrict (or use your old logic)
  if (!navigator.locks) return;

  const blockTab = () =>
    window.location.replace(`/${c.PAGE_URLS[c.PAGE_TAB_RESTRICT]}`);

  const tryAcquire = (retriesLeft) => {
    navigator.locks.request(LOCK_NAME, { ifAvailable: true }, (lock) => {
      if (!lock) {
        // On refresh, the old document may not have released the lock yet.
        if (retriesLeft > 0) {
          setTimeout(() => tryAcquire(retriesLeft - 1), 300);
        } else {
          blockTab();
        }
        return;
      }

      // Hold the lock for the lifetime of this tab by never resolving.
      return new Promise(() => {});
    });
  };

  tryAcquire(3);
};

restrictTabs();